import React from 'react';
import CommunityRulesPanel from './CommunityRulesPanel';

const REPORT_REASONS = [
  { value: 'spam', label: 'Spam' },
  { value: 'harassment', label: 'Harassment' },
  { value: 'hate', label: 'Hate' },
  { value: 'sexual_content', label: 'Sexual content' },
  { value: 'other', label: 'Other' },
];

export default function ReportModal({
  open,
  title = 'Report',
  reason,
  note,
  submitting = false,
  onReasonChange,
  onNoteChange,
  onCancel,
  onSubmit,
  submitLabel = 'Submit Report',
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[2000] bg-black/60 p-4 flex items-center justify-center">
      <div className="w-full max-w-md rounded-xl border border-slate-700 bg-slate-900 p-4">
        <h3 className="text-lg font-bold text-slate-100 mb-3">{title}</h3>
        <label className="block text-xs text-slate-400 mb-1">Reason</label>
        <select
          value={reason}
          onChange={(e) => onReasonChange?.(e.target.value)}
          className="w-full rounded-lg bg-slate-800 border border-slate-700 px-3 py-2 text-slate-100 mb-3"
        >
          {REPORT_REASONS.map((r) => (
            <option key={r.value} value={r.value}>{r.label}</option>
          ))}
        </select>
        <label className="block text-xs text-slate-400 mb-1">Note (optional)</label>
        <textarea
          value={note}
          onChange={(e) => onNoteChange?.(e.target.value)}
          rows={3}
          maxLength={500}
          className="w-full rounded-lg bg-slate-800 border border-slate-700 px-3 py-2 text-slate-100"
          placeholder="Add details to help moderation review."
        />
        <div className="mt-3">
          <CommunityRulesPanel title="Community Rules" compact />
        </div>
        <div className="mt-4 flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 rounded-lg bg-slate-700 hover:bg-slate-600 text-slate-100 py-2 font-semibold"
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="flex-1 rounded-lg bg-red-600 hover:bg-red-500 text-white py-2 font-semibold disabled:opacity-60"
            disabled={submitting}
          >
            {submitting ? 'Submitting...' : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

